import type { ReactElement } from 'react';
import { FixedAssetSync } from './FixedAssetSync';
import { RegulatoryPackUpgrade } from './RegulatoryPackUpgrade';
import { TaxreturnGroupJournals } from './TaxreturnGroupJournals';
import { TaxreturnGroupStructure } from './TaxreturnGroupStructure';
import { TaxreturnGroupTrialbalance } from './TaxreturnGroupTrialbalance';
import { TaxreturnPartnerAccounts } from './TaxreturnPartnerAccounts';
import { TaxreturnProfitAllocation } from './TaxreturnProfitAllocation';

/** Ported screens of this slice, keyed by their Angular URL (see src/app/routeManifest.ts). */
export const screens: Record<string, ReactElement> = {
  '/home/taxreturns/tasks-profitallocation': <TaxreturnProfitAllocation />,
  '/home/taxreturns/tasks-partneraccounts': <TaxreturnPartnerAccounts />,
  '/home/taxreturns/tasks-groupstructure': <TaxreturnGroupStructure />,
  '/home/taxreturns/tasks-grouptrialbalance': <TaxreturnGroupTrialbalance />,
  '/home/taxreturns/tasks-groupjournals': <TaxreturnGroupJournals />,
  '/home/taxreturns/regulatory-pack-upgrade': <RegulatoryPackUpgrade />,
  '/home/taxreturns/fixed-asset-sync': <FixedAssetSync />,
};
